var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExamResourcesWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-exam-resources-white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.134,
    height: 133.483,
    viewBox: "0 0 100.134 133.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2110",
    "data-name": "Ret\\xE2ngulo 2110",
    width: 100.134,
    height: 133.483,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1857",
    "data-name": "Caminho 1857",
    d: "M72.987,106.446h11.27l-11.27,11.27ZM59.9,70.452c2.016-.771,2.6-2.457,2.6-4.5q-.033-20.725-.01-41.448V14.421H87.782c.019.438.059.9.06,1.35q0,4.367.005,8.732c.008,1.541.736,2.389,1.97,2.365,1.184-.022,1.893-.855,1.934-2.3.014-.56,0-1.122,0-1.773h4.366V129.484H14.483v-4.353h1.586q26.132,0,52.265.022a7.786,7.786,0,0,0,5.92-2.459q7.5-7.618,15.115-15.115a7.676,7.676,0,0,0,2.408-5.811q-.044-33.693-.018-67.386a9.9,9.9,0,0,0-.023-1.171,2,2,0,0,0-1.993-1.862,1.944,1.944,0,0,0-1.881,1.944c-.03.433-.014.868-.014,1.3v67.831H86.378c-4.3,0-8.6-.008-12.9,0a4.022,4.022,0,0,0-4.433,3.562,4.086,4.086,0,0,0,0,.877c-.017,4.258,0,8.515,0,12.774v1.492H6.1V70.792H25.191q16.015,0,32.028-.014v.009c.137.006.274.01.41.01a7.648,7.648,0,0,0,2.277-.345M12.329,31.423c0-.024,0-.049,0-.074h.006q-.129-10.621,0-21.246A6.335,6.335,0,0,1,24.718,8.347c-1.849,0-3.648-.008-5.449,0-1.591.009-2.54.782-2.5,2.012.039,1.189.935,1.893,2.477,1.893q18.768.008,37.539,0H58.46V66.793H3.992V12.378h4.4v1.363c0,5.822-.071,11.645.022,17.465a10.289,10.289,0,0,0,15.481,8.908,9.783,9.783,0,0,0,5.089-8.557c.083-2.909.068-5.822.018-8.732a6.075,6.075,0,0,0-6.011-6.11,6.172,6.172,0,0,0-6.217,5.937c-.078,1.386-.054,2.78-.012,4.17a1.951,1.951,0,0,0,1.755,2.13,1.82,1.82,0,0,0,.205.009c1.156,0,1.9-.792,1.925-2.139.03-1.216-.014-2.44.017-3.65a2.311,2.311,0,0,1,2.066-2.532c.053-.005.1-.009.157-.01A2.247,2.247,0,0,1,25.11,22.9a2.048,2.048,0,0,1-.015.25c.022,2.7.044,5.394-.009,8.081a6.293,6.293,0,0,1-6.235,6.35h-.231a6.294,6.294,0,0,1-6.29-6.164M17.225,0A10.793,10.793,0,0,0,9.607,5.559c-.446.877-.754,1.822-1.156,2.794-1.334,0-2.679-.01-4.022,0A4.11,4.11,0,0,0,.04,12.164a4.394,4.394,0,0,0,0,.6c-.017,2.607,0,5.214,0,7.819q0,22.744-.006,45.486V66.1A4,4,0,0,0,1.23,69.5a2.539,2.539,0,0,1,.909,2.373q-.023,24.181-.013,48.355c0,3.383,1.532,4.9,4.951,4.9h3.4v3.3c0,3.587,1.468,5.049,5.06,5.049h79.5c3.6,0,5.065-1.459,5.065-5.038V23.4a4.17,4.17,0,0,0-4.6-4.6c-1.2-.006-2.409,0-3.751,0V15.316c0-3.317-1.553-4.88-4.853-4.88H80.825q-8.82,0-17.643-.019a2.176,2.176,0,0,1-1.476-.452,4.882,4.882,0,0,0-3.944-1.618c-9.253.023-18.506,0-27.759.027-.8,0-1.2-.149-1.44-1.027a9.094,9.094,0,0,0-4.085-5.522A32.993,32.993,0,0,0,20.353,0Z",
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1859",
    "data-name": "Caminho 1859",
    d: "M24.509,68.407a1.771,1.771,0,0,0-1.657,1.726,1.752,1.752,0,0,0,1.33,1.981,5.618,5.618,0,0,0,1.542.155q22.023.012,44.048,0a5.7,5.7,0,0,0,1.54-.15,1.9,1.9,0,0,0-.289-3.709,9.184,9.184,0,0,0-1.174-.045H25.809c-.109,0-.218-.005-.327-.005q-.487,0-.972.045",
    transform: "translate(-22.831 -68.362)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1861",
    "data-name": "Caminho 1861",
    d: "M24.514,60.274a1.906,1.906,0,0,0-.209,3.743,6.362,6.362,0,0,0,1.42.117q22.025.01,44.048,0h.085a6.4,6.4,0,0,0,1.214-.076,1.916,1.916,0,0,0-.167-3.8c-.275-.027-.552-.032-.83-.032H69.6v0H25.945c-.122,0-.245-.005-.369-.005-.354,0-.708.015-1.062.049",
    transform: "translate(-22.847 -60.225)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1863",
    "data-name": "Caminho 1863",
    d: "M53.595,76.491H53.35V76.5H26.015c-.433,0-.868-.009-1.3.018a1.847,1.847,0,0,0-1.868,1.8,1.942,1.942,0,0,0,1.762,2.055,5.8,5.8,0,0,0,.909.028q13.869,0,27.731-.008h.243a1.914,1.914,0,0,0,1.253-.229,3.725,3.725,0,0,0,1.148-1.949c.113-.882-.578-1.506-1.5-1.669a4.4,4.4,0,0,0-.7-.057h-.1",
    transform: "translate(-22.84 -76.49)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1865",
    "data-name": "Caminho 1865",
    d: "M13.385,76.517h0a1.9,1.9,0,0,0-1.947,1.847v.013a1.8,1.8,0,0,0,1.635,1.96l.06.005a29.569,29.569,0,0,0,4.673,0,1.736,1.736,0,0,0,1.676-1.794,1.317,1.317,0,0,0-.015-.175,1.768,1.768,0,0,0-1.7-1.843h-.1c-.732-.059-1.474-.012-2.209-.012v-.008c-.43,0-.863-.013-1.293-.013-.257,0-.527,0-.787.019",
    transform: "translate(-11.434 -76.498)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1867",
    "data-name": "Caminho 1867",
    d: "M57.014,21.227v.005a1.717,1.717,0,0,0-1.621,1.808,1.62,1.62,0,0,0,.024.207,1.781,1.781,0,0,0,1.771,1.791c.026,0,.051,0,.078,0,.69.044,1.387.009,2.078.008h.69c.512,0,1.015.012,1.52-.012a1.8,1.8,0,0,0,1.867-1.726v-.065a1.74,1.74,0,0,0-1.44-2c-.056-.009-.114-.015-.171-.019-.792-.068-1.592-.1-2.39-.1s-1.61.035-2.409.1",
    transform: "translate(-55.392 -21.123)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1869",
    "data-name": "Caminho 1869",
    d: "M56.9,29.41l0-.012a1.683,1.683,0,0,0-1.514,1.833,1.853,1.853,0,0,0,.046.263,1.764,1.764,0,0,0,1.834,1.669c.691.036,1.386.006,2.079.006.737,0,1.473.023,2.209,0a1.8,1.8,0,0,0,1.874-1.718v-.063a1.678,1.678,0,0,0-1.345-1.956q-.069-.012-.139-.019c-.863-.074-1.731-.114-2.6-.114-.818,0-1.636.036-2.44.11",
    transform: "translate(-55.378 -29.3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1871",
    "data-name": "Caminho 1871",
    d: "M13.252,68.393h-.005a1.78,1.78,0,0,0-1.785,1.734,1.67,1.67,0,0,0,1.3,1.973c.049.009.1.017.149.023a29.428,29.428,0,0,0,5.168-.012c1.027-.1,1.494-.984,1.388-2.025A1.721,1.721,0,0,0,17.8,68.408c-.769-.068-1.556-.014-2.337-.014v-.009c-.453,0-.91-.014-1.364-.014-.281,0-.564,0-.842.022",
    transform: "translate(-11.427 -68.371)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1873",
    "data-name": "Caminho 1873",
    d: "M59.39,37.414c-.742,0-1.485.023-2.222.065v0a1.917,1.917,0,0,0,.064,3.826c.687.051,1.384.009,2.078.009V41.3c.78,0,1.562.046,2.337-.01a1.777,1.777,0,0,0,1.779-1.773c0-.032,0-.064,0-.1A1.757,1.757,0,0,0,61.845,37.5c-.046,0-.091-.006-.136-.008-.738-.05-1.482-.077-2.225-.077H59.39",
    transform: "translate(-55.41 -37.414)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1875",
    "data-name": "Caminho 1875",
    d: "M15.543,60.224q-1.115,0-2.227.032h0a1.829,1.829,0,0,0-1.87,1.789v.009A1.9,1.9,0,0,0,13.2,64.083h.018a19.409,19.409,0,0,0,2.2.015v-.006a19.917,19.917,0,0,0,2.333-.018,1.815,1.815,0,0,0,1.73-1.9c0-.053-.008-.105-.014-.158a1.777,1.777,0,0,0-1.779-1.77q-.048,0-.1,0-.975-.031-1.951-.031h-.1",
    transform: "translate(-11.438 -60.224)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1877",
    "data-name": "Caminho 1877",
    d: "M57,45.65v0A1.669,1.669,0,0,0,55.4,47.385a1.328,1.328,0,0,0,.012.144,1.717,1.717,0,0,0,1.562,1.861l.048,0a18.865,18.865,0,0,0,2.333.019v.017c.779,0,1.563.056,2.335-.013a1.777,1.777,0,0,0,1.744-1.807c0-.033,0-.067-.005-.1a1.71,1.71,0,0,0-1.54-1.862l-.086-.005q-1.181-.073-2.369-.073-1.215,0-2.427.081",
    transform: "translate(-55.398 -45.569)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1879",
    "data-name": "Caminho 1879",
    d: "M44.708,37.424H12.285v.005h-.2c-.349-.008-.75-.014-.926.167a4.084,4.084,0,0,0-1.3,1.866,1.63,1.63,0,0,0,1.447,1.793l.068.005a7.283,7.283,0,0,0,1.251.069H44.273a6.864,6.864,0,0,0,1.338-.081,1.733,1.733,0,0,0,1.479-1.734,1.759,1.759,0,0,0-1.234-1.926,3.525,3.525,0,0,0-1.065-.166h-.083",
    transform: "translate(-9.85 -37.423)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1881",
    "data-name": "Caminho 1881",
    d: "M29.766,21.154v.012a1.949,1.949,0,0,0-2.046,1.847,1.607,1.607,0,0,0,0,.208,1.923,1.923,0,0,0,2.015,1.831.878.878,0,0,0,.1-.006c1.691.027,3.385.006,5.078,0h1.551c1.176,0,2.353.01,3.528-.013a1.864,1.864,0,0,0,2.024-1.687,1.845,1.845,0,0,0,.006-.207,1.891,1.891,0,0,0-1.8-1.98c-.058,0-.116,0-.172,0q-2.6-.037-5.207-.036-2.539,0-5.079.032",
    transform: "translate(-27.718 -21.122)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1883",
    "data-name": "Caminho 1883",
    d: "M29.944,29.288h-.005a2,2,0,0,0-2.208,1.767,1.93,1.93,0,0,0-.012.258c.032,1.134.85,1.848,2.2,1.866,1.65.022,3.3,0,4.947,0s3.3.015,4.947,0c1.386-.018,2.163-.692,2.2-1.853a1.958,1.958,0,0,0-1.863-2.048,1.913,1.913,0,0,0-.321.01q-2.462-.027-4.924-.026-2.485,0-4.97.026",
    transform: "translate(-27.719 -29.262)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4101",
    "data-name": "Grupo 4101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4100",
    "data-name": "Grupo 4100",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1856",
    "data-name": "Caminho 1856",
    d: "M72.986,106.446h11.27l-11.27,11.27ZM57.219,70.787a7.7,7.7,0,0,0,2.685-.335c2.017-.771,2.6-2.457,2.6-4.5q-.033-20.725-.01-41.448V14.421H87.782c.021.438.059.9.06,1.35q0,4.367.006,8.732c.006,1.541.735,2.389,1.969,2.365,1.185-.022,1.893-.855,1.934-2.3.015-.56,0-1.122,0-1.773h4.366V129.484H14.483v-4.353h1.586q26.134,0,52.266.022a7.785,7.785,0,0,0,5.92-2.459q7.5-7.618,15.115-15.115a7.685,7.685,0,0,0,2.408-5.811q-.046-33.693-.019-67.386a9.9,9.9,0,0,0-.023-1.171,2,2,0,0,0-1.992-1.862,1.945,1.945,0,0,0-1.883,1.944c-.03.433-.013.868-.013,1.3v67.831H86.379c-4.3,0-8.6-.008-12.9,0a4.022,4.022,0,0,0-4.433,3.562,4.087,4.087,0,0,0,0,.877c-.018,4.258,0,8.515,0,12.774v1.492H6.1V70.792H25.192q16.013,0,32.028-.014M12.334,31.348q-.129-10.621,0-21.246A6.336,6.336,0,0,1,24.719,8.347c-1.849,0-3.65-.008-5.45,0-1.59.009-2.539.782-2.5,2.012.037,1.189.935,1.893,2.476,1.893q18.77.008,37.539,0H58.46V66.793H3.994V12.378h4.4v1.363c0,5.822-.071,11.645.022,17.465a10.289,10.289,0,0,0,15.481,8.908,9.786,9.786,0,0,0,5.091-8.557c.082-2.909.068-5.822.017-8.732a6.074,6.074,0,0,0-6.011-6.11,6.173,6.173,0,0,0-6.217,5.937c-.078,1.386-.053,2.78-.012,4.17a1.951,1.951,0,0,0,1.755,2.13c.068.006.137.009.205.009,1.156,0,1.9-.792,1.926-2.139.028-1.216-.015-2.44.015-3.65a2.312,2.312,0,0,1,2.068-2.532c.051-.005.1-.009.155-.01A2.249,2.249,0,0,1,25.111,22.9a2.343,2.343,0,0,1-.017.25c.022,2.7.044,5.394-.009,8.081a6.293,6.293,0,0,1-6.235,6.35h-.1a6.292,6.292,0,0,1-6.42-6.163c0-.024,0-.05,0-.074M17.225,0A10.8,10.8,0,0,0,9.607,5.559c-.444.877-.754,1.822-1.156,2.794-1.333,0-2.678-.01-4.022,0a4.109,4.109,0,0,0-4.388,3.81,4.012,4.012,0,0,0,0,.6c-.018,2.607,0,5.214,0,7.819q0,22.744-.008,45.486V66.1a4,4,0,0,0,1.2,3.407,2.538,2.538,0,0,1,.908,2.373q-.021,24.181-.013,48.355c0,3.383,1.533,4.9,4.951,4.9h3.4v3.3c0,3.587,1.468,5.049,5.06,5.049h79.5c3.6,0,5.066-1.459,5.066-5.038V23.4a4.171,4.171,0,0,0-4.6-4.6c-1.2-.006-2.41,0-3.752,0V15.316c0-3.317-1.551-4.88-4.853-4.88H80.825q-8.82,0-17.642-.019a2.18,2.18,0,0,1-1.477-.452,4.88,4.88,0,0,0-3.942-1.618c-9.254.023-18.506,0-27.76.027-.8,0-1.2-.149-1.438-1.027a9.1,9.1,0,0,0-4.086-5.522A33.1,33.1,0,0,0,20.353,0Z",
    transform: "translate(0)",
    fill: "#0d0d0d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon-exam-resources-white-2",
    "data-name": "icon-exam-resources-white",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4102",
    "data-name": "Grupo 4102",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2694",
    "data-name": "Caminho 2694",
    d: "M0,0H100.087V133.482H0Z",
    transform: "translate(0.023 0.001)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4105",
    "data-name": "Grupo 4105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4104",
    "data-name": "Grupo 4104",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1858",
    "data-name": "Caminho 1858",
    d: "M47.705,68.367H25.81a10.731,10.731,0,0,0-1.3.04,1.771,1.771,0,0,0-1.655,1.726,1.75,1.75,0,0,0,1.33,1.981,5.6,5.6,0,0,0,1.541.155q22.025.012,44.048,0a5.764,5.764,0,0,0,1.541-.15,1.9,1.9,0,0,0-.289-3.709,8.98,8.98,0,0,0-1.175-.045H47.705",
    transform: "translate(6.488 19.427)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4107",
    "data-name": "Grupo 4107",
    transform: "translate(29.319 87.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4106",
    "data-name": "Grupo 4106",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2113",
    "data-name": "Ret\\xE2ngulo 2113",
    width: 49.991,
    height: 3.923,
    transform: "translate(-0.062 -0.006)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4109",
    "data-name": "Grupo 4109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4108",
    "data-name": "Grupo 4108",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1860",
    "data-name": "Caminho 1860",
    d: "M69.6,60.23H25.946a11.314,11.314,0,0,0-1.431.044,1.906,1.906,0,0,0-.209,3.743,6.349,6.349,0,0,0,1.42.117q22.023.01,44.048,0h.083a6.4,6.4,0,0,0,1.214-.076,1.916,1.916,0,0,0-.166-3.8c-.275-.027-.552-.032-.83-.032H69.6",
    transform: "translate(6.493 17.115)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4111",
    "data-name": "Grupo 4111",
    transform: "translate(29.339 77.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4110",
    "data-name": "Grupo 4110",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2115",
    "data-name": "Ret\\xE2ngulo 2115",
    width: 49.883,
    height: 3.926,
    transform: "translate(-0.03 -0.01)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4113",
    "data-name": "Grupo 4113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4112",
    "data-name": "Grupo 4112",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1862",
    "data-name": "Caminho 1862",
    d: "M53.351,76.5H26.016c-.434,0-.869-.009-1.3.018a1.848,1.848,0,0,0-1.87,1.8,1.943,1.943,0,0,0,1.762,2.055,5.973,5.973,0,0,0,.909.028q13.869,0,27.732-.008h.241a1.914,1.914,0,0,0,1.253-.229,3.725,3.725,0,0,0,1.148-1.949c.113-.882-.578-1.506-1.5-1.669a4.463,4.463,0,0,0-.8-.055H53.35",
    transform: "translate(6.491 21.737)",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4115",
    "data-name": "Grupo 4115",
    transform: "translate(29.331 98.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4114",
    "data-name": "Grupo 4114",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2117",
    "data-name": "Ret\\xE2ngulo 2117",
    width: 33.278,
    height: 3.935,
    transform: "translate(-0.116 0.005)",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4117",
    "data-name": "Grupo 4117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4116",
    "data-name": "Grupo 4116",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1864",
    "data-name": "Caminho 1864",
    d: "M13.39,76.519a1.9,1.9,0,0,0-1.948,1.847v.013a1.807,1.807,0,0,0,1.636,1.961l.06,0a29.553,29.553,0,0,0,4.672,0,1.735,1.735,0,0,0,1.676-1.794,1.6,1.6,0,0,0-.014-.175,1.771,1.771,0,0,0-1.7-1.843h-.1c-.732-.059-1.473-.012-2.209-.012v-.008c-.43,0-.862-.013-1.293-.013-.257,0-.525,0-.787.019",
    transform: "translate(3.249 21.74)",
    fill: "#fff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4119",
    "data-name": "Grupo 4119",
    transform: "translate(14.684 98.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4118",
    "data-name": "Grupo 4118",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2119",
    "data-name": "Ret\\xE2ngulo 2119",
    width: 8.092,
    height: 3.996,
    transform: "translate(-0.004 -0.026)",
    fill: "#fff"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4121",
    "data-name": "Grupo 4121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4120",
    "data-name": "Grupo 4120",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1866",
    "data-name": "Caminho 1866",
    d: "M57.015,21.232a1.718,1.718,0,0,0-1.621,1.808,1.854,1.854,0,0,0,.024.207,1.781,1.781,0,0,0,1.771,1.791h.078c.691.044,1.387.009,2.079.008h.688c.514,0,1.015.012,1.52-.012a1.8,1.8,0,0,0,1.867-1.726c0-.022,0-.044,0-.065a1.741,1.741,0,0,0-1.441-2c-.056-.009-.113-.015-.171-.019-.791-.068-1.591-.1-2.39-.1s-1.61.035-2.409.1",
    transform: "translate(15.742 6.003)",
    fill: "#fff"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4123",
    "data-name": "Grupo 4123",
    transform: "translate(71.134 27.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4122",
    "data-name": "Grupo 4122",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2121",
    "data-name": "Ret\\xE2ngulo 2121",
    width: 8.17,
    height: 3.953,
    transform: "translate(-0.053 0.005)",
    fill: "#fff"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4125",
    "data-name": "Grupo 4125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4124",
    "data-name": "Grupo 4124",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1868",
    "data-name": "Caminho 1868",
    d: "M56.9,29.4a1.679,1.679,0,0,0-1.514,1.833,1.662,1.662,0,0,0,.046.263,1.762,1.762,0,0,0,1.833,1.669c.691.036,1.386.006,2.079.006.737,0,1.474.023,2.209,0a1.8,1.8,0,0,0,1.874-1.72v-.062a1.679,1.679,0,0,0-1.346-1.956q-.069-.012-.139-.019c-.862-.074-1.731-.114-2.6-.114-.818,0-1.635.036-2.44.11",
    transform: "translate(15.738 8.327)",
    fill: "#fff"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4127",
    "data-name": "Grupo 4127",
    transform: "translate(71.116 37.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4126",
    "data-name": "Grupo 4126",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2123",
    "data-name": "Ret\\xE2ngulo 2123",
    width: 8.215,
    height: 3.906,
    transform: "translate(-0.078 -0.012)",
    fill: "#fff"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4129",
    "data-name": "Grupo 4129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4128",
    "data-name": "Grupo 4128",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1870",
    "data-name": "Caminho 1870",
    d: "M13.246,68.394a1.779,1.779,0,0,0-1.784,1.734,1.67,1.67,0,0,0,1.3,1.973c.049.009.1.018.149.023a29.428,29.428,0,0,0,5.168-.012c1.027-.1,1.494-.984,1.388-2.025A1.72,1.72,0,0,0,17.8,68.408c-.771-.068-1.558-.014-2.337-.014v-.009c-.455,0-.91-.014-1.365-.014-.281,0-.562,0-.842.022",
    transform: "translate(3.248 19.43)",
    fill: "#fff"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4131",
    "data-name": "Grupo 4131",
    transform: "translate(14.674 87.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4130",
    "data-name": "Grupo 4130",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2125",
    "data-name": "Ret\\xE2ngulo 2125",
    width: 8.207,
    height: 3.931,
    transform: "translate(-0.063 -0.031)",
    fill: "#fff"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4133",
    "data-name": "Grupo 4133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4132",
    "data-name": "Grupo 4132",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1872",
    "data-name": "Caminho 1872",
    d: "M57.168,37.476a1.917,1.917,0,0,0,.063,3.826c.688.051,1.384.009,2.078.009V41.3c.78,0,1.562.046,2.337-.01a1.776,1.776,0,0,0,1.779-1.773c0-.032,0-.065,0-.1A1.759,1.759,0,0,0,61.845,37.5q-.067-.006-.135-.008-1.156-.079-2.321-.077c-.741,0-1.483.023-2.22.065",
    transform: "translate(15.747 10.632)",
    fill: "#fff"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4135",
    "data-name": "Grupo 4135",
    transform: "translate(71.156 48.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4134",
    "data-name": "Grupo 4134",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2127",
    "data-name": "Ret\\xE2ngulo 2127",
    width: 8.112,
    height: 3.942,
    transform: "translate(-0.074 -0.004)",
    fill: "#fff"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4137",
    "data-name": "Grupo 4137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4136",
    "data-name": "Grupo 4136",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1874",
    "data-name": "Caminho 1874",
    d: "M13.313,60.257a1.83,1.83,0,0,0-1.87,1.789v.009A1.9,1.9,0,0,0,13.2,64.083h.018a19.734,19.734,0,0,0,2.2.015v-.006a19.923,19.923,0,0,0,2.333-.018,1.814,1.814,0,0,0,1.729-1.9c0-.053-.008-.105-.014-.158a1.773,1.773,0,0,0-1.779-1.768l-.1,0q-1.027-.033-2.055-.031-1.113,0-2.227.032",
    transform: "translate(3.251 17.115)",
    fill: "#fff"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4139",
    "data-name": "Grupo 4139",
    transform: "translate(14.689 77.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4138",
    "data-name": "Grupo 4138",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2129",
    "data-name": "Ret\\xE2ngulo 2129",
    width: 8.253,
    height: 3.942,
    transform: "translate(-0.12 0.001)",
    fill: "#fff"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4141",
    "data-name": "Grupo 4141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4140",
    "data-name": "Grupo 4140",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1876",
    "data-name": "Caminho 1876",
    d: "M57,45.654A1.67,1.67,0,0,0,55.4,47.385a1.355,1.355,0,0,0,.012.144,1.716,1.716,0,0,0,1.562,1.859l.049,0a19.117,19.117,0,0,0,2.333.019v.017c.778,0,1.563.056,2.335-.013a1.776,1.776,0,0,0,1.743-1.807c0-.033,0-.065-.005-.1a1.708,1.708,0,0,0-1.54-1.861l-.086-.006q-1.181-.073-2.369-.073-1.215,0-2.427.081",
    transform: "translate(15.743 12.95)",
    fill: "#fff"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4143",
    "data-name": "Grupo 4143",
    transform: "translate(71.141 58.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4142",
    "data-name": "Grupo 4142",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2131",
    "data-name": "Ret\\xE2ngulo 2131",
    width: 8.025,
    height: 3.921,
    transform: "translate(0.009 0.004)",
    fill: "#fff"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4145",
    "data-name": "Grupo 4145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4144",
    "data-name": "Grupo 4144",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1878",
    "data-name": "Caminho 1878",
    d: "M12.284,37.429h-.2c-.351-.008-.75-.014-.927.167a4.084,4.084,0,0,0-1.3,1.866,1.63,1.63,0,0,0,1.449,1.793l.067.005a7.164,7.164,0,0,0,1.252.069H44.274a6.852,6.852,0,0,0,1.337-.081,1.733,1.733,0,0,0,1.481-1.734,1.76,1.76,0,0,0-1.234-1.926,3.524,3.524,0,0,0-1.149-.164H12.285",
    transform: "translate(2.799 10.635)",
    fill: "#fff"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4147",
    "data-name": "Grupo 4147",
    transform: "translate(12.649 48.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4146",
    "data-name": "Grupo 4146",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2133",
    "data-name": "Ret\\xE2ngulo 2133",
    width: 37.429,
    height: 3.922,
    transform: "translate(-0.128 -0.01)",
    fill: "#fff"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4149",
    "data-name": "Grupo 4149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4148",
    "data-name": "Grupo 4148",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1880",
    "data-name": "Caminho 1880",
    d: "M29.766,21.166a1.947,1.947,0,0,0-2.044,1.847,1.873,1.873,0,0,0,0,.208,1.927,1.927,0,0,0,2.016,1.833q.05,0,.1-.008c1.693.027,3.385.006,5.079,0h1.551c1.176,0,2.351.01,3.526-.013a1.862,1.862,0,0,0,2.024-1.687,1.843,1.843,0,0,0,.008-.207,1.894,1.894,0,0,0-1.8-1.98c-.058,0-.114,0-.172,0q-2.6-.037-5.206-.036-2.541,0-5.08.032",
    transform: "translate(7.877 6.003)",
    fill: "#fff"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4151",
    "data-name": "Grupo 4151",
    transform: "translate(35.595 27.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4150",
    "data-name": "Grupo 4150",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2135",
    "data-name": "Ret\\xE2ngulo 2135",
    width: 14.38,
    height: 3.94,
    transform: "translate(-0.058 0.012)",
    fill: "#fff"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4153",
    "data-name": "Grupo 4153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4152",
    "data-name": "Grupo 4152",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1882",
    "data-name": "Caminho 1882",
    d: "M29.939,29.288a2,2,0,0,0-2.208,1.767,2.171,2.171,0,0,0-.012.258c.033,1.134.851,1.848,2.2,1.866,1.649.022,3.3,0,4.947,0s3.3.015,4.947,0c1.386-.018,2.163-.692,2.2-1.853a1.959,1.959,0,0,0-1.863-2.05,2.048,2.048,0,0,0-.32.012q-2.462-.025-4.925-.026-2.485,0-4.97.026",
    transform: "translate(7.878 8.316)",
    fill: "#fff"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4155",
    "data-name": "Grupo 4155",
    transform: "translate(35.597 37.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4154",
    "data-name": "Grupo 4154",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2137",
    "data-name": "Ret\\xE2ngulo 2137",
    width: 14.379,
    height: 3.939,
    transform: "translate(-0.034 0)",
    fill: "#fff"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4157",
    "data-name": "Grupo 4157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4156",
    "data-name": "Grupo 4156",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1884",
    "data-name": "Caminho 1884",
    d: "M10.482,31.348q-.129-10.621,0-21.246A6.336,6.336,0,0,1,22.867,8.347l5.284.027c-.8,0-1.2-.149-1.438-1.027a9.1,9.1,0,0,0-4.086-5.522A33.1,33.1,0,0,0,18.5,0H15.372A10.8,10.8,0,0,0,7.755,5.559C7.31,6.436,7,7.381,6.6,8.354L6.54,12.378v1.363c0,5.822-.071,11.645.022,17.465a10.289,10.289,0,0,0,15.481,8.908,9.786,9.786,0,0,0,5.091-8.557c.082-2.909.068-5.822.017-8.732a6.074,6.074,0,0,0-6.011-6.11,6.173,6.173,0,0,0-6.217,5.937c-.078,1.386-.053,2.78-.012,4.17a1.951,1.951,0,0,0,1.755,2.13c.068.006.137.009.205.009,1.156,0,1.9-.792,1.926-2.139.028-1.216-.015-2.44.015-3.65a2.312,2.312,0,0,1,2.068-2.532c.051-.005.1-.009.155-.01A2.249,2.249,0,0,1,23.259,22.9a2.342,2.342,0,0,1-.017.25c.022,2.7.044,5.394-.009,8.081A6.293,6.293,0,0,1,17,37.586h-.1a6.292,6.292,0,0,1-6.42-6.163c0-.024,0-.05,0-.074",
    transform: "translate(1.851)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExamResourcesWhite);
export default __webpack_public_path__ + "static/media/icon-exam-resources-white.07c7f91440b52ce860c092d48a022127.svg";
export { ForwardRef as ReactComponent };